import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      fisPersid: 'aboutme/fisPersid',
      activeTab: 'aboutme/getActiveTab',
      resourceTypes: 'aboutme/resourceTypes',
      name: 'aboutme/name'
    }),
    activeResourceType () {
      return this.resourceTypes[this.activeTab].type
    },
    toCurrentRoute () {
      let to = {
        name: 'aboutme',
        params: {
          type: 'person',
          id: this.fisPersid,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      }
      return to
    }
  },
  methods: {
    loadAsyncData () {
      this.$store.dispatch('aboutme/fetchResearchActivities', this.activeResourceType)
    },
    setFirstPage () {
      this.$store.dispatch('aboutme/setConfig', {
        resourceType: this.activeResourceType,
        property: 'page',
        value: 1
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/AboutMeHelper.js